import { addDays, endOfMonth, format, startOfMonth } from 'date-fns'
import * as React from 'react'
import { useMemo } from 'react'
import { DATE_FORMAT_YYYY_MM_DD } from '../../constants'
import { CalendarModeEnum, IDate, IDateCheckout, ITravelDate } from '../../store/data'
import { getDatesForCalendarDate } from '../../utils/dates'
import CalendarWrapper from './CalendarWrapper'
import { useLocale } from './helpers'

type CalendarContentProps = {
  checkouts: IDateCheckout[]
  data: IDate[]
  date: Date
  isFetching: boolean
  mode: CalendarModeEnum
  onSelectDate: (date: Date) => void
  travelDate: ITravelDate
}

const CalendarContent: React.FunctionComponent<CalendarContentProps> = ({
  checkouts = [],
  data = [],
  date,
  isFetching = false,
  mode,
  onSelectDate,
  travelDate,
}) => {
  const leftCalendarDate = date
  const rightCalendarDate = addDays(endOfMonth(date), 1)

  const locale = useLocale()

  const leftCalendarDates = useMemo(() => {
    const dateCacheKey = format(startOfMonth(leftCalendarDate), DATE_FORMAT_YYYY_MM_DD)
    return getDatesForCalendarDate(dateCacheKey, data)
  }, [data, leftCalendarDate])

  const rightCalendarDates = useMemo(() => {
    const dateCacheKey = format(startOfMonth(rightCalendarDate), DATE_FORMAT_YYYY_MM_DD)
    return getDatesForCalendarDate(dateCacheKey, data)
  }, [data, rightCalendarDate])

  return (
    <div className="calendar-content">
      <CalendarWrapper
        checkouts={checkouts}
        data={isFetching ? [] : leftCalendarDates}
        date={leftCalendarDate}
        isFetching={isFetching}
        locale={locale}
        mode={mode}
        onSelectDate={onSelectDate}
        travelDate={travelDate}
      />
      <CalendarWrapper
        checkouts={checkouts}
        data={isFetching ? [] : rightCalendarDates}
        date={rightCalendarDate}
        isFetching={isFetching}
        locale={locale}
        mode={mode}
        onSelectDate={onSelectDate}
        secondary
        travelDate={travelDate}
      />
    </div>
  )
}

export default CalendarContent
